import React, { forwardRef } from "react";
import { mergeClasses } from "@fluentui/react-components";

import { useYellowPadLogoStyles } from "./styles";

import logo from "../../../assets/logo.png";

export interface YellowPadLogoProps extends React.ComponentPropsWithoutRef<"img"> {}

export const YellowPadLogo = forwardRef<HTMLImageElement, YellowPadLogoProps>(({ className, ...props }, ref) => {
  const styles = useYellowPadLogoStyles();
  return (
    <img
      ref={ref}
      src={logo}
      width={20}
      height={20}
      alt="Yellowpad"
      loading="eager"
      className={mergeClasses(styles.logo, className)}
      {...props}
    />
  );
});
YellowPadLogo.displayName = "YellowPadLogo";
